(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bf-help-widget"] && !Shopify.designMode) return;
  try {
    class BFHelpWidget extends HTMLElement {
    connectedCallback() {
      this.fab    = this.querySelector('.bf-help__fab');
      this.panel  = this.querySelector('.bf-help__panel');
      this.closeB = this.querySelector('.bf-help__close');
      this.form   = this.querySelector('.bf-help__form');
      this.status = this.querySelector('.bf-help__status');
      this.send   = this.querySelector('.bf-help__send');

      this.fab.addEventListener('click', () => this.toggle());
      this.closeB.addEventListener('click', () => this.setOpen(false));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen()) this.setOpen(false); });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.watchStickyAtc();
    }
    watchStickyAtc() {
      // Lift the widget when bf-sticky-atc becomes visible (PDP scroll past main ATC).
      const sticky = document.querySelector('bf-sticky-atc');
      if (!sticky) return;
      const update = () => {
        const r = sticky.getBoundingClientRect();
        const visible = r.height > 0 && r.top < window.innerHeight && r.bottom > 0;
        this.classList.toggle('bf-help--shifted', visible);
      };
      const mo = new MutationObserver(update);
      mo.observe(sticky, { attributes: true, attributeFilter: ['class', 'style', 'data-visible', 'hidden'] });
      if (window.ResizeObserver) new ResizeObserver(update).observe(sticky);
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      setTimeout(update, 800);
    }
    isOpen()       { return this.dataset.open === 'true'; }
    toggle()       { this.setOpen(!this.isOpen()); }
    setOpen(open)  {
      this.dataset.open = open ? 'true' : 'false';
      this.fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.panel.hidden = !open;
      if (open) this.closeB.focus({preventScroll:true});
      else this.fab.focus({preventScroll:true});
    }
    showStatus(msg, state) {
      this.status.textContent = msg;
      this.status.hidden = !msg;
      if (state) this.status.dataset.state = state; else delete this.status.dataset.state;
    }
    async onSubmit(e) {
      e.preventDefault();
      this.send.disabled = true;
      this.showStatus('Sending…', '');
      try {
        const fd = new FormData(this.form);
        const r  = await fetch(this.form.action, { method: 'POST', body: fd, credentials: 'include', redirect: 'follow' });
        if (r.ok || r.status === 302) {
          this.form.reset();
          this.showStatus('Message sent. We\'ll reply to your email.', 'ok');
        } else {
          this.showStatus('Couldn\'t send. Please try again.', 'error');
        }
      } catch (err) {
        this.showStatus('Couldn\'t send. Please try again.', 'error');
      } finally {
        this.send.disabled = false;
      }
    }
  }
  if (!customElements.get('bf-help-widget')) customElements.define('bf-help-widget', BFHelpWidget);
  } catch(e) { console.error(e); }
})();

})();
